import { find } from '@execonline-inc/collections';
import { Maybe, nothing } from 'maybeasy';
import { createContext } from 'react';
import EventsStore from '.';
import { EventResource } from './Types';

// The participant's events store, shared so that the dashboard cards can open the same
// event details as the events list.
export const EventsStoreContext = createContext<Maybe<EventsStore>>(nothing());

export const findEvent = (eventsStore: EventsStore, id: number): Maybe<EventResource> =>
  eventsStore.events.andThen((eventsResource) =>
    find((event: EventResource) => event.payload.id === id, eventsResource.payload),
  );
